// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"8393bb31","148":"3d5069eb"}[chunkId] + ".chunk.js";
};